import {createUseStyles} from 'react-jss'

import {
  COLORS
} from '~styles/vars.styles'

import {
  borderSeparator,
  input,
  inputLegacy,
  link
} from '~styles/mixins.styles'

export default createUseStyles({
  /**
   * jss-plugin-global uses `@global` decorator allowing us
   * to style against the php form's search results.  These
   * class names are defined by the old php form.
   */
  '@global': {
    "#search_results": {
      fontWeight: 400
    },
    '.preferred_notice strong': {
      display: 'block',
      marginBottom: 20,
      fontSize: 20
    },
    '#long_search_results_notice': {
      background: COLORS.LIGHT_02,
      color: COLORS.BLUE_MUTED_02,
      fontWeight: 600,
      padding: 20,
      borderRadius: 10,
      marginBottom: 20
    },

    '.search_result_link': {
      ...link({
        color: COLORS.BLUE_02,
        fontWeight: 600
      })
    },
    '.search_result_zipcode': {
      fontSize: 14,
      color: COLORS.BLUE_MUTED_02
    },
    '.search_result_category': {
      fontSize: 14,
      color: COLORS.BLUE_MUTED_02,
      '& + div': {
        marginBottom: 10
      }
    },
    '.selected-organization': {
      background: COLORS.ACCENT
    }
  },

  input: {
    ...input,
    ...inputLegacy()
  },

  button: {
    marginTop: 20
  },

  searchResults: {
    ...borderSeparator('top')
  }
})